<!-- Group Image Content -->
<section>
  <div class="flex-after-sale gap-image-content item-image">
    <div class="text-layout text-layout-size">
      <h2 class="font-withe text-title" [innerHTML]="dataSignal().groupImageContent.header"></h2>
      <p class="text-description" [innerHTML]="dataSignal().groupImageContent.title"></p>
    </div>
    @if (dataSignal().groupImageContent.subtitle?.length) {
    <div class="flex-after-sale gap-after-sale w-content bg-primary text-list-items">
      @for (item of dataSignal().groupImageContent.subtitle; track $index) {
      <span class="icon-check">{{ item.headers }}</span>
      }
    </div>
    }
  </div>
</section>
<!-- Group Description Content -->
<section class="flex-after-sale gap-after-sale text-content">
  <h3 class="text-content-title">{{ dataSignal().topic }}</h3>
  @for (item of dataSignal().groupDescriptionContent; track $index) {
  <p class="text-content-list">{{ item.title }}</p>
  @if (item.subtitle) { @for (sub of item.subtitle; track $index; let last = $last) {
  <section class="flex-after-sale gap-after-sale">
    <span class="icon-check w-icon-s text-content-list topic-layout" [ngClass]="{ 'topic-last ': last }">
      <strong>
        <span class="text-topic">{{ sub.topic }}</span>
        {{ sub.subtopic }}
      </strong>
      {{ sub.title }}
    </span>
  </section>
  } } }
</section>